/*
 * Copyright Mission 42 Ventures, Inc. All rights reserved.
 * Unauthorized copying, distribution, or use is prohibited.
 */
import { scaffolderPlugin } from '@backstage/plugin-scaffolder';
import { createScaffolderFieldExtension } from '@backstage/plugin-scaffolder-react';
import {
  ServiceRepoAutocomplete,
  serviceRepoAutocompleteValidation,
} from './ServiceRepoAutocompleteExtension';

export const ServiceRepoAutocompleteExtension = scaffolderPlugin.provide(
  createScaffolderFieldExtension({
    name: 'ServiceRepoAutocomplete',
    component: ServiceRepoAutocomplete,
    validation: serviceRepoAutocompleteValidation,
  }),
);
